import { render, staticRenderFns } from "./TwoPackSelector.vue?vue&type=template&id=1a55e15f"
import script from "./TwoPackSelector.vue?vue&type=script&lang=js"
export * from "./TwoPackSelector.vue?vue&type=script&lang=js"
import style0 from "./TwoPackSelector.vue?vue&type=style&index=0&id=1a55e15f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports